import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import './Advertising.css';
import strokeImage from '../../assets/social-icons/stroke2.png'

const Advertising = () => {
  const ref = useRef(null);

  return (
    <div className="advertising-wrapper" ref={ref}>
      <motion.div className="advertising-content" >
        <div className="text-block-container">
          <span className="main-text">
            <span className="sub-text">We're</span>
            <img src={strokeImage} alt="Decorative stroke" aria-hidden="true" />{' '}
            This is the future of marketing<span className="fullStop">.</span>
          </span>
        </div>
      </motion.div>
    </div>
  );
};

export default Advertising;